/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableProps } from 'antd';
import React from 'react';
import './Table.less';
import * as S from './Table.styles';

interface NewTableProps extends TableProps<any> {
  hasBorder?: boolean;
}

// TODO make generic!
export const Table: React.FC<NewTableProps> = (props) => {
  const { hasBorder } = props;

  return (
    <S.Table
      {...props}
      $hasBorder={hasBorder}
      //@ts-ignore
      pagination={{ ...props.pagination, showSizeChanger: false, defaultPageSize: 8, position: ['bottomCenter'] }}
    />
  );
};
